import { getESignEndpointFromLifecycle, getInvoiceV2EndpointFromLifecycle } from "./apiUtils";
import { getCultureFromLcid } from "./enumutils";

export type ValidateFunc = () => boolean | Promise<boolean>;

export const changeLifecycle = async (documentType: server.dto.DocumentTypes, targetLifecycle: server.dto.DocumentLifeCycles, documentId: number, validateFunc?: ValidateFunc) => {
  let valid = true;
  if (validateFunc) {
    valid = await validateFunc();
  }

  if (!valid) return false;

  const endpoint = documentType === "invoice" ? getInvoiceV2EndpointFromLifecycle(targetLifecycle) : getESignEndpointFromLifecycle(targetLifecycle);
  await endpoint(documentId);

  window.location.reload();
  return true;
};

export const generatePdfName = (documentNumber: string, version?: number) => {
  if (!documentNumber) {
    const date = new Date();
    const docName = `${date.getFullYear()} ${date.getMonth() + 1} ${date.getDate()} DRAFT`;

    return encodeURIComponent(docName + ".pdf");
  }
  const versionString = version ? `_rev${version}` : "";

  const documentNumberString = documentNumber?.replace(/\//g, "_") ?? "file";

  return encodeURIComponent(documentNumberString + versionString + ".pdf");
};

export const getLcidFromParticipant = (linkedToUser: server.dto.UserSmall, contact: server.dto.ContactSmallV2) => {
  if (!linkedToUser && !contact) return null
  return linkedToUser?.culture ?? contact?.culture ?? "english_GB";
}

export const getCultureFromParticipant = (linkedToUser: server.dto.UserSmall, contact: server.dto.ContactSmallV2) => {
  return getCultureFromLcid(getLcidFromParticipant(linkedToUser, contact));
}